<template>
  <card class="m-1 p-0">
    <div class="row">
      <div class="col-md-7">
        <h4 slot="header" class="card-title">
          Detalle del servicio:
          <span v-if="form_update">{{ form_update.service_code }}</span>
        </h4>
        <p style="font-size: 14px">
          Los detalles de esta ruta se actualizan cada 10 segundos en esta
          ventana, puedes presionar en "Actualizar mapa" para ver las
          actualizaciones.
        </p>
      </div>
      <div class="col-md-5 text-center">
        <h3>
          <span style="font-size: 12px">Estatus: </span>
          <span class="badge bg-warning" v-if="form_update.status_service">{{
            form_update.status_service.name
          }}</span>
        </h3>

        <h4>
          <span style="font-size: 12px">Tipo: </span>
          <span
            class="text-right badge bg-success"
            v-if="form_update.type_route"
            >Servicio de {{ form_update.type_route.name }}</span
          >
        </h4>
      </div>
    </div>

    <form>
      <div class="row">
        <button
          type="button"
          class="btn btn-info btn-fill float-right mx-auto"
          @click.prevent="getElement()"
        >
        <v-icon name="sync" class="mx-1" fill="white"></v-icon>
          Actualizar mapa 
      </button>
      </div>
      <div class="row container-md mt-md-auto pt-1 mx-auto px-auto">
        <div class="col-12 col-md-12 pt-2 px-0">
          <GmapMap
            :center="center"
            :zoom="15"
            map-style-id="roadmap"
            :options="mapOptions"
            style="width: 100%; height: 120vmin"
            ref="mapRef"
          >
            <GmapMarker
              :position="marker.position"
              :clickable="false"
              :draggable="false"
              :icon="marker.icon"
            />

            <GmapMarker
              :position="marker.position_initial"
              :clickable="false"
              :draggable="false"
              :icon="marker.icon_blue"
            />
            <GmapMarker
              :position="marker.position_end"
              :clickable="false"
              :draggable="false"
              :icon="marker.icon_red"
            />
          </GmapMap>

          <p>
            Última ubicación recibida:
            {{
              form_update.latitude_driver + ' / ' + form_update.longitude_driver
            }}
          </p>
        </div>
      </div>

      <div class="row pt-4">
        <div class="col-4 col-md-6">
          <button
            type="button"
            class="btn btn-secondary btn-fill float-left"
            @click="goBack"
            style="border-radius: 25px !important"
          >
          <v-icon name="angle-left" class="mx-1" fill="white"></v-icon>
            <strong>Volver</strong>
          </button>
        </div>
        <div class="col-8 col-md-6 d-flex justify-content-end">
          <button
            type="submit"
            class="btn btn-info btn-fill float-right"
            @click.prevent="goToMaps(form_update)"
            style="border-radius: 25px !important"
          >
            <strong>Ver en Maps</strong>
          </button>
        </div>
      </div>

      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Card from 'src/components/Cards/Card.vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
export default {
  components: {
    Card,
    Multiselect
  },
  data() {
    return {
      position_history: 0,
      buttonList: 'Services',
      labelTitle: 'Detalles del form_update',
      labelAction: 'Editar form_update',
      userRating: [],
      messageUser: '',
      form_update: {
        id: 0,
        id_user_children: 0,
        id_user_driver: 0,
        id_route: 0,
        latitude_star: '',
        longitude_star: '',
        latitude_end: '',
        longitude_end: '',
        hour: '',
        observation: '',
        id_status_service: 1
      },
      daysOfWeek: [
        { value: 1, label: 'Lunes' },
        { value: 2, label: 'Martes' },
        { value: 3, label: 'Miércoles' },
        { value: 4, label: 'Jueves' },
        { value: 5, label: 'Viernes' },
        { value: 6, label: 'Sábado' },
        { value: 7, label: 'Domingo' }
      ],
      routeTMP: [],
      usersTMP: [],
      userChildrenTMP: [],
      currentLocationTMP: [],
      currentLocation: {},
      marker: { position: { lat: 10, lng: 10 } },
      marker_history: { position: { lat: 10, lng: 10 } },
      marker_initial: { position: { lat: 10, lng: 10 } },
      marker_end: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: true
      },
      userRepresentative: {},
      intervalId: null,
      history: [],
      active: false,
      show: false
    }
  },
  mounted() {
    this.getElement()
    this.getAllHistory()
    //Load every 30 seconds
    this.intervalId = setInterval(() => {
      this.getElement()
      this.getAllHistory()
    }, 10000)

    console.log(this.intervalId)
  },
  destroyed() {
    clearInterval(this.intervalId)

    console.log('unmounted')
    console.log(this.intervalId)
  },
  methods: {
    ...mapActions(['getData', 'updateData']),
    goToMaps(form_update) {
      window.open(
        'https://www.google.com/maps/search/?api=1&query=' +
          form_update.latitude_driver +
          ',' +
          form_update.longitude_driver,
        '_blank'
      )
    },
    formatDate(date) {
      //format with moment with UTC -4

      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    addPosition() {
      if (this.position_history == this.history.length - 1) {
        return
      }
      this.position_history++
      this.setPosition()
    },
    removePosition() {
      if (this.position_history == 0) {
        return
      }
      this.position_history--
      this.setPosition()
    },
    setPosition() {
      let lat = this.history[this.position_history].lat
      let lng = this.history[this.position_history].lon
      console.log(lat, lng)
      this.marker_history.position = {
        lat: parseFloat(this.history[this.position_history].lat.toString()),
        lng: parseFloat(this.history[this.position_history].lon.toString())
      }
      this.marker_history.icon = {
        url: this.form_update.driver.url_image,
        scaledSize: new google.maps.Size(40, 40)
      }
    },
    openMap() {
      $('#modalMap').modal('toggle')
      this.form_save = {}
      this.modalActiveSave = true
    },
    togglemodalMap() {
      const body = document.querySelector('body')
    },
    getAllHistory() {
      let form = {
        url: 'service_history/all',
        params: {
          id_service: this.$route.params.id
        }
      }

      this.isBusy = true
      this.getData(form)
        .then((response) => {
          this.isBusy = false
          if (response.code === 200) {
            this.history = response.data.locations
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getElement() {
      let id = this.$route.params.id
      this.loaded = false
      let data_params = {
        url: 'service/' + id,
        params: {
          order_by: 'id',
          order_key: 'desc'
        }
      }

      this.getData(data_params)
        .then((response) => {
          this.form_update = response.data

          this.loadSelects('route')
          this.loadSelects('user_children')
          this.loadSelects('user')
          this.fetchUserRating()

          this.marker.position_initial = {
            lat: parseFloat(this.form_update.latitude_star),
            lng: parseFloat(this.form_update.longitude_star)
          }
          this.marker.position_end = {
            lat: parseFloat(this.form_update.latitude_end),
            lng: parseFloat(this.form_update.longitude_end)
          }
          this.marker.icon_blue = {
            url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
            scaledSize: new google.maps.Size(40, 40)
          }
          this.marker.icon_red = {
            url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
            scaledSize: new google.maps.Size(40, 40)
          }

          this.marker.position = {
            lat: parseFloat(this.form_update.latitude_driver.toString()),
            lng: parseFloat(this.form_update.longitude_driver.toString())
          }
          this.marker.icon = {
            url: this.form_update.driver.url_image,
            scaledSize: new google.maps.Size(40, 40)
          }
          this.center = {
            lat: parseFloat(this.form_update.latitude_driver.toString()),
            lng: parseFloat(this.form_update.longitude_driver.toString())
          }
          console.log(this.marker)

          if (this.form_update.children.id_user_parent) {
            this.loadRepresentative(this.form_update.children.id_user_parent)
          }

          this.loaded = true
        })
        .catch((error) => {
          this.loaded = true
          console.log(error)
        })
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl })
    },
    loadRepresentative(id) {
      let form = {
        url: 'user/' + id,
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          this.userRepresentative = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },

    goNew() {
      this.$router.push({ name: this.buttonNewUrl })
    },
    goToRoute(id) {
      this.$router.push('/admin/routes/edit/' + id)
    },
    goBack() {
      window.history.go(-1)
    },
    getUserName({ full_name, email }) {
      return `${full_name} — ${email}`
    },
    loadSelects(master) {
      let form = {
        url: master + '/all',
        params: {
          active: 1
        }
      }
      if (master === 'user') {
        form.params.id_role = 2
        form.params.is_driver = 1
        form.params.is_representative = 0
      }

      this.isBusy = true
      this.getData(form)
        .then((response) => {
          this.isBusy = false
          if (response.code === 200) {
            if (master == 'route') {
              this.routeTMP = response.data
              // Asigna el objeto de ruta seleccionada al modelo form_update.route
              const selectedRoute = this.routeTMP.find(
                (route) => route.id === this.form_update.id_route
              )
              // Check if the route is found before assignment
              if (selectedRoute) {
                this.form_update.route = selectedRoute
              } else {
                // Log an error or handle the situation where the route is not found
                console.error('Route not found:', this.form_update.id_route)
              }
            }
            if (master == 'user') {
              this.usersTMP = response.data.map((user) => {
                return {
                  id: user.id,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  email: user.email,
                  full_name: `${user.first_name} ${user.last_name} - ${user.email}`
                }
              })
              const selectedUser = this.usersTMP.find(
                (userr) => userr.id === this.form_update.id_user_driver
              )
              this.form_update.user = selectedUser
            }
            if (master == 'user_children') {
              this.userChildrenTMP = response.data.map((user) => {
                return {
                  id: user.id,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  email: user.email,
                  full_name: `${user.first_name} ${user.last_name}`
                }
              })

              const selectedUserChildren = this.userChildrenTMP.find(
                (userChildren) =>
                  userChildren.id === this.form_update.id_user_children
              )
              this.form_update.user_children = selectedUserChildren
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // userMessage() {
    //   axios.get('https://apitest.maranathapp.com/api/1.0/user_rating/all?id_driver=' + this.form_update.id_driver + "&id_service=" + this.$route.params.id)
    //     .then(response => {
    //       this.messageUser = response.data.data;
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    fetchUserRating() {
      // try {
      //   console.log(this.$route.params.id)
      //   const response = await axios.get('https://apitest.maranathapp.com/api/1.0/user_rating/all?id_user=' + this.form_update.id_user + "&id_service=" + this.$route.params.id)
      //   this.userRating = response.data.data[0].rating;
      // } catch (error) {
      //   console.error(error)
      // }

      let data_params = {
        url: 'user_rating/all?id_service=' + this.$route.params.id,
        params: {}
      }

      this.getData(data_params)
        .then((response) => {
          // this.form_update = response.data;

          if (response.data.length > 0) {
            this.userRating = response.data[0].rating
            this.messageUser = response.data[0].message
          }

          this.loaded = true
        })
        .catch((error) => {
          this.loaded = true
          console.log(error)
        })
    },
    updateElement() {
      Swal.fire({
        title: '¡Actualizar!',
        text: '¿Estás seguro de actualizar este form_update?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: '#651366',
        cancelButtonColor: '#F76E2A',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Actualizar'
      }).then((result) => {
        if (result.value) {
          this.deleting = true
          let form = {
            url: 'service/update',
            id: this.form_update.id,
            data: {
              id_user_children: this.form_update.user_children.id,
              id_user_driver: this.form_update.user.id,
              id_route: this.form_update.route.id,
              latitude_star: this.form_update.latitude_star,
              longitude_star: this.form_update.longitude_star,
              latitude_end: this.form_update.latitude_end,
              longitude_end: this.form_update.longitude_end,
              hour: this.form_update.hour,
              observation: this.form_update.observation,
              id_status_service: this.form_update.id_status_service
            }
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false
                Swal.fire({
                  title: 'Servicio actualizado correctamente',
                  icon: 'success',
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000
                })

                this.$router.push({ name: this.buttonList })
              }
            })
            .catch((error) => {
              console.log(error)
              this.deleting = false
              alert('Ocurrió un error, intente más tarde')
            })
        }
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
